/**
 * Ürün Karşılaştırma Drawer
 * yapaycicekal.com — Be Yours 8.4.0
 *
 * - Custom element (theme editor reload uyumlu)
 * - Body scroll lock
 * - ESC ile kapatma
 * - Focus yönetimi
 * - Drawer kapatıldığında video pause
 */
if (!customElements.get('product-karsilastirma')) {
  class ProductKarsilastirma extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector('[data-ycd-open]');
      this.drawer = this.querySelector('.ycd-drawer');
      this.closeButtons = this.querySelectorAll('[data-ycd-close]');
      this.video = this.querySelector('.ycd-drawer__video');
      this.handleKeydown = this.handleKeydown.bind(this);
    }

    connectedCallback() {
      if (!this.trigger || !this.drawer) return;

      this.trigger.addEventListener('click', () => this.open());
      this.closeButtons.forEach((btn) => {
        btn.addEventListener('click', () => this.close());
      });
    }

    open() {
      this.drawer.setAttribute('aria-hidden', 'false');
      this.trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('ycd-drawer-open');
      document.addEventListener('keydown', this.handleKeydown);

      const closeBtn = this.drawer.querySelector('.ycd-drawer__close');
      window.requestAnimationFrame(() => {
        if (closeBtn) closeBtn.focus();
      });

      // Sessiz autoplay (mobil/masaüstü uyumlu)
      if (this.video) {
        try {
          this.video.currentTime = 0;
          const p = this.video.play();
          if (p !== undefined) p.catch(() => {});
        } catch (e) {}
      }
    }

    close() {
      this.drawer.setAttribute('aria-hidden', 'true');
      this.trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('ycd-drawer-open');
      document.removeEventListener('keydown', this.handleKeydown);

      if (this.video && !this.video.paused) {
        this.video.pause();
      }

      window.requestAnimationFrame(() => {
        this.trigger.focus();
      });
    }

    handleKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
      }
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.handleKeydown);
      document.body.classList.remove('ycd-drawer-open');
    }
  }

  customElements.define('product-karsilastirma', ProductKarsilastirma);
}